// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"391":"374f6d2d","831":"eb67f19f"}[chunkId] + ".chunk.css";
};